'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.screensaver.add', [])
  .controller('ScreenSaverAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/screenSaver/add/index.js